import { render, staticRenderFns } from "./certuficatp.vue?vue&type=template&id=1ef0dac5"
import script from "./certuficatp.vue?vue&type=script&lang=js"
export * from "./certuficatp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports